import React from 'react'

import { usePreventRouteChange } from './usePreventRouteChange'
import { useTracking } from './useTracking'
import { useAppStore } from 'lib/store'
import { EVENT_NAMES } from 'lib/tracking'

export function useUnsavedChangesModal(formRef: React.RefObject<HTMLFormElement>, hasChanges: boolean) {
	const store = useAppStore()
	const track = useTracking()

	const displayModal = React.useCallback(() => {
		store.dispatch({ type: 'currentModal/set', payload: 'UnsavedChangesModal' })
		track(EVENT_NAMES.MODAL_DISPLAYED, { name: 'Unsaved changes' })
	}, [store, track])
	const hideModal = React.useCallback(() => {
		store.dispatch({ type: 'currentModal/set', payload: null })
		track(EVENT_NAMES.MODAL_CLOSED, { name: 'Unsaved changes', action: 'Stay here' })
	}, [store, track])

	const { continueRouteChange } = usePreventRouteChange(hasChanges, displayModal)

	const handleDiscardChanges = React.useCallback(() => {
		formRef.current?.reset()
		hideModal()
		track(EVENT_NAMES.MODAL_CLOSED, { name: 'Unsaved changes', action: 'Discard changes' })
		continueRouteChange()
	}, [formRef, hideModal, continueRouteChange, track])

	return {
		hideModal,
		handleDiscardChanges,
	}
}
